var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 0.25H2.125C1.62772 0.25 1.15081 0.447544 0.799175 0.799175C0.447544 1.15081 0.25 1.62772 0.25 2.125L0.25 15.875C0.25 16.3723 0.447544 16.8492 0.799175 17.2008C1.15081 17.5525 1.62772 17.75 2.125 17.75H7.48633V11.8004H5.02539V9H7.48633V6.86562C7.48633 4.43789 8.93164 3.09687 11.1453 3.09687C12.2055 3.09687 13.3141 3.28594 13.3141 3.28594V5.66875H12.0926C10.8891 5.66875 10.5137 6.41562 10.5137 7.18164V9H13.2004L12.7707 11.8004H10.5137V17.75H15.875C16.3723 17.75 16.8492 17.5525 17.2008 17.2008C17.5525 16.8492 17.75 16.3723 17.75 15.875V2.125C17.75 1.62772 17.5525 1.15081 17.2008 0.799175C16.8492 0.447544 16.3723 0.25 15.875 0.25Z",
    fill: "#292830"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.aa1017ffbd23ea354ec79681486ba96f.svg";
export { ForwardRef as ReactComponent };